/*
 * This file converts all of the global styles in globals.less to constants that can be
 * used in styled components.
 */

/*******************************
     User Global Variables
*******************************/

// TODO: This is out of date, update to match our semantic variables!
// Globals colors
export const importGoogleFonts = `false`;
// export const fontName = `graphein`;
// export const pageFont = `graphein`;
export const fontName = `Source Sans Pro`;
export const pageFont = `Source Sans Pro`;
export const panelIconFont = `panel-icons`;
export const primaryColor = `#007faf`;
export const secondaryColor = `#7a7b7e`;
export const yellow = `#ffc933`;
export const gold = `#ffcc33`;
export const fullYellow = `#ffff00`;
export const red = `#ff5447`;
export const darkRed = `#ff2514`;
export const deepTeal = `#039cad`;
export const teal = `#03b7b7`;
export const green = `#29c68c`;
export const blue = `#007faf`;
export const deepBlue = `#00648f`;

export const heartColor = `rgb(189, 112, 163)`;

// extended colors (These are only used in PanelMultiRunTable currently).
export const seaFoamGreen = `#7ed2bf`;
export const lightSeaFoamGreen = `#edf8f6`;
export const slateBlue = `#68abca`;
export const lightSlateBlue = `#e9f3f7`;
export const lightYellowOther = `#fff2cc`;
export const lightYellow = `#fffbec`;
export const goldenrod = `#daa300`;

export const someOtherLightBlue = `#e0f3ff`;

// privacy badge colors
export const fern = `#3ac26c`; // public
export const aqua = `#21bfa4`; // team
export const cerulean = `#37a0c7`; // private
export const orchid = `#a97ccd`; // open

export const darkestGray = `#1a1c1f`;
export const darkGray = `#363a3d`;
export const gray = `#515457`;
export const lightGray = `#aaa`;
export const veryLightGray = `#d2d2d2`;
export const veryVeryLightGray = `#f4f4f4`;
export const lightestGray = `#f9f9f9`;
export const white = `#fff`;

export const textColor = darkGray;
export const lightTextColor = `#b4b4b4`;
export const lightBlue = `#ddedfc`;
export const mediumBlue = `#80b3f8`;
export const darkBlue = `#338dd8`;
export const linkBlue = blue; // color used for links
export const linkHoverBlue = `#006c95`;
export const deepBlue2 = `#072548`; // Kasparov stands no chance against our color scheme
export const deepBlueLighter = `#1e446f`;
export const sky = `#e8f6fd`; // highlighted table cell
export const lightSky = `#f3fafd`; // highlighted table row/col

export const standardButtonColor = blue;
export const backgroundColor = lightestGray;
export const outlineColor = `#dbdbdb`;

// error colors
export const errorBackgroundColor = `#fff6f6`;
export const errorTextColor = `#9f3a38`;
export const errorBoxShadow = `0 0 0 1px #e0b4b4 inset, 0 0 0 0 transparent`;

// Shared CSS Rules
export const accordionContentPadding = `25px 20px`;
export const transitionTime = `0.3s`;
export const actionAnimationTime = `0.3s`;
export const backgroundColorTransition = `background-color ${transitionTime} linear`;
export const borderColorTransition = `border-color ${transitionTime} linear`;
export const pillBorderRadius = `20px`;
export const tabletBreakpoint = `768px`;

export const tagPurple = `#e5d6ff`;
export const tagBerry = `#ffd6f0`;
export const tagRed = `#ffe0e0`;
export const tagPeach = `#ffe7cc`;
export const tagYellow = `#fde8ad`;
export const tagAcid = `#c9f5b5`;
export const tagGreen = `#c2f2da`;
export const tagTeal = `#c0f0ed`;
export const tagBlue = `#d6efff`;
export const tagMidnight = `#e0e4ff`;

export const galleryPurple = `#364BA8`;
export const galleryPurpleGradient = `linear-gradient(60deg, #463173, #2964C2)`;
export const galleryNavPurple = `#3B4693`;
export const galleryNavPurpleGradient = `linear-gradient(60deg, #463173, #2F5AB2)`;

// Box shadows

// Box shadows at different levels from material
export const levelNavbarBoxShadow = `0 1px 3px rgba(0, 0, 0, 0.02),
0 1px 2px rgba(0, 0, 0, 0.12)`;
export const level1BoxShadow = `0 1px 3px rgba(0, 0, 0, 0.12),
0 1px 2px rgba(0, 0, 0, 0.24)`;
export const level2BoxShadow = `0 3px 6px rgba(0, 0, 0, 0.16),
0 3px 6px rgba(0, 0, 0, 0.23)`;
export const level3BoxShadow = `0 10px 20px rgba(0, 0, 0, 0.19),
0 6px 6px rgba(0, 0, 0, 0.23)`;
export const level3BoxShadowFaint = `0 10px 20px rgba(0, 0, 0, 0.07),
0 6px 6px rgba(0, 0, 0, 0.07)`;
export const level4BoxShadow = `0 14px 28px rgba(0, 0, 0, 0.25),
0 10px 10px rgba(0, 0, 0, 0.22)`;
export const level5BoxShadow = `0 19px 38px rgba(0, 0, 0, 0.30),
0 15px 12px rgba(0, 0, 0, 0.22)`;

export const boxShadowButtonsCharts = `0px 1px 3px 0px rgba(54,58,61,0.12)`;
export const boxShadowButtonsChartsHover = `0px 3px 6px 0px rgba(54,58,61,0.12)`;
export const boxShadowModal = `0px 8px 16px 0px rgba(54,58,61,0.16)`;
export const boxShadowDropdown = `0px 4px 8px 0px rgba(54,58,61,0.12)`;
export const boxShadowSection = `1px 1px 20px 0px #e6e6e6`;

// Inner tab box-shadow
export const tabBoxShadow = `inset 0 -4px 25px -8px rgba(0, 0, 0, 0.2)`;

// Font sizes
export const fontSizeStandard = `16px`;
export const lineHeightStandard = `24px`;
export const fontWeightStandard = `100`;

// Sizes
export const navbarHeight = `0px`;

// Spacing
export const pageHeaderButtonSpacing = `10px`;
export const standardSpacingUnit = `8px`;
export const spu = standardSpacingUnit;

// Functional Color Rules
// These should wrap the above colors with semantic names
// TODO = Figure out how tofontSizeStandard organize this
// Action Colors, buttons,
export const actionButtonFocusedColor = deepTeal;
export const actionButtonFocusedFontColor = white;
export const actionButtonFocusedBorderColor = deepTeal;

export const actionButtonActiveColor = teal;
export const actionButtonActiveFontColor = white;
export const actionButtonActiveBorderColor = teal;

export const actionButtonDefaultColor = veryVeryLightGray;
export const actionButtonDefaultFontColor = textColor;
export const actionButtonDefaultBorderColor = `transparent`;

export const actionFocusedColor = `rgb(236, 248, 255)`;
export const actionFocusedFontColor = textColor;

export const actionActiveColor = someOtherLightBlue;
export const actionActiveFontColor = textColor;

export const separatorBorder = `1px solid ${outlineColor}`;

export const searchNavHeight = `52px`;
export const galleryNavHeight = `52px`;
export const fancyPageSidebarWidth = `52px`;
export const mobileBarHeight = fancyPageSidebarWidth;
export const reportCoverHorizontalMargin = `28px`;
export const reportDraftBackgroundColor = `rgb(255, 248, 227)`;
export const reportFontSize = `18px`;
